import { getLocalizedPath } from "./getLocalizedPath";

/**
 * Returns the dashboard path the user should be redirected to based on their app access.
 * - RMS if user has RMS (or both)
 * - FMS if user has only FMS
 * - Defaults to RMS if no apps
 */
export const getDashboardRedirectPath = (user) => {
  const u = user?.user ?? user;
  const apps = u?.apps || [];
  const hasRms = apps.some((app) => app.slug === "rms");
  const hasFms = apps.some((app) => app.slug === "fms");
  const path = hasRms ? "/rms/dashboard" : hasFms ? "/fms/dashboard" : "/rms/dashboard";
  return getLocalizedPath(path);
};
